import { createApp } from 'vue'

import { initSentry } from '@/javascripts/utils/sentry_helper';

import FreshSlideForm from '@/javascripts/components/fresh_slide_form.vue';
const app = createApp(FreshSlideForm);
initSentry(app);
app.mount('#form');
